import { useState } from "react";
import styled from "styled-components";
import { EyeIcon } from "@ficatranquilo/contabilidade.com-ui";
import { formatCNPJ, formatCPF, maskCPF } from "./format";

const Root = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

const Kind = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  line-height: ${({ theme }) => theme.fontSizes.large_x};
  color: ${({ theme }) => theme.colors.N400};
`;

const Reveal = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50px;
  color: ${({ theme }) => theme.colors.N400};
  cursor: pointer;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.N100};
    color: ${({ theme }) => theme.colors.N900};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.FOCUS};
  }
`;

/**
 * CNPJ sempre completo e mascarado. CPF completo em detalhe e formulário; em
 * listas, `hidden` mostra "***.456.789-**" com botão para revelar (LGPD).
 * `showKind={false}` tira o selo CNPJ/CPF (quando o rótulo já diz qual é).
 */
export default function DocumentNumber({ value, hidden = false, showKind = true, className }) {
  const digits = String(value || "").replace(/\D/g, "");
  const isCnpj = digits.length > 11;
  const [masked, setMasked] = useState(hidden && !isCnpj);
  if (!digits) return <span className={className}>—</span>;
  const text = isCnpj ? formatCNPJ(digits) : masked ? maskCPF(digits) : formatCPF(digits);
  const toggleLabel = masked ? "Mostrar CPF" : "Ocultar CPF";
  return (
    <Root className={className}>
      {showKind ? <Kind>{isCnpj ? "CNPJ" : "CPF"}</Kind> : null}
      <span>{text}</span>
      {!isCnpj && hidden ? (
        <Reveal type="button" onClick={() => setMasked(!masked)} aria-label={toggleLabel} title={toggleLabel}>
          <EyeIcon $status={masked} />
        </Reveal>
      ) : null}
    </Root>
  );
}
